"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

var KnownError =
/** @class */
function () {
  function KnownError() {
    this.code = null;
    this.message = null;
    this.description = null;
    this.troubleshootMessage = null;
    this.isActive = null;
  }

  KnownError.thaw = function (knownErrorObj) {
    if (knownErrorObj == null) return null;
    var knownError = new KnownError();

    if (knownErrorObj.code != null) {
      knownError.setCode(knownErrorObj.code);
    }

    if (knownErrorObj.message != null) {
      knownError.setMessage(knownErrorObj.message);
    }

    if (knownErrorObj.description != null) {
      knownError.setDescription(knownErrorObj.description);
    }

    if (knownErrorObj.troubleshootMessage != null) {
      knownError.setTroubleshootMessage(knownErrorObj.troubleshootMessage);
    }

    if (knownErrorObj.isActive != null) {
      knownError.setIsActive(knownErrorObj.isActive == null ? null : knownErrorObj.isActive ? true : false);
    }

    return knownError;
  };

  KnownError.thawList = function (knownErrorList) {
    if (knownErrorList == null) {
      return [];
    }

    var knownErrors = [];

    for (var i = 0; i < knownErrorList.length; i++) {
      knownErrors.push(KnownError.thaw(knownErrorList[i]));
    }

    return knownErrors;
  };

  KnownError.freeze = function (knownError) {
    if (knownError == null) {
      return null;
    }

    var knownErrorObj = {};

    if (knownError.getCode() != null) {
      knownErrorObj.code = knownError.getCode();
    }

    if (knownError.getMessage() != null) {
      knownErrorObj.message = knownError.getMessage();
    }

    if (knownError.getDescription() != null) {
      knownErrorObj.description = knownError.getDescription();
    }

    if (knownError.getTroubleshootMessage() != null) {
      knownErrorObj.troubleshootMessage = knownError.getTroubleshootMessage();
    }

    if (knownError.getIsActive() != null) {
      knownErrorObj.isActive = knownError.getIsActive() == null ? null : knownError.getIsActive() ? 1 : 0;
    }

    return knownErrorObj;
  };

  KnownError.freezeList = function (knownErrors) {
    if (knownErrors == null) {
      return [];
    }

    var knownErrorObjList = [];

    for (var i = 0; i < knownErrors.length; i++) {
      knownErrorObjList.push(KnownError.freeze(knownErrors[i]));
    }

    return knownErrorObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  KnownError.prototype.setCode = function (code) {
    this.code = code;
  };

  KnownError.prototype.setMessage = function (message) {
    this.message = message;
  };

  KnownError.prototype.setDescription = function (description) {
    this.description = description;
  };

  KnownError.prototype.setTroubleshootMessage = function (troubleshootMessage) {
    this.troubleshootMessage = troubleshootMessage;
  };

  KnownError.prototype.setIsActive = function (isActive) {
    this.isActive = isActive;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  KnownError.prototype.getCode = function () {
    return this.code;
  };

  KnownError.prototype.getMessage = function () {
    return this.message;
  };

  KnownError.prototype.getDescription = function () {
    return this.description;
  };

  KnownError.prototype.getTroubleshootMessage = function () {
    return this.troubleshootMessage;
  };

  KnownError.prototype.getIsActive = function () {
    return this.isActive;
  };

  return KnownError;
}();

var _default = KnownError;
exports.default = _default;